import { get, post } from '../utils/gd-axios';
//检查是否评价
export const checkEvaluateStatus = (params) => { return get('/bookingapi/api/checkEvaStatus', params); };

// V2.0 接口
// index 接口
export const getNewDict = (params) => post('/prm/api/v2/dict/basic/getBasicNewDict', params);
export const getListAndPermission = (params) => get('/elune/api/v1/booking/getListAndPermission', params);

//查询所有团队
export const getOtherTeam = (params) => get('/elune/api/v1/booking/other/team', params);

//取消预约
export const cancelBooking = (params) => get(`/elune/api/v1/booking/cancelBooking/${params.id}`);

//提交评论
export const evaluateBooking = (params) => post('/elune/api/v1/booking/evaluateBooking', params);

// 提交预约
export const addBooking = (params) => post('/elune/api/v1/booking/addBooking', params);

// 预约页面获取科目，次数、周期
export const getCountNum = (params) => get(`/elune/api/v1/booking/member/booking/subject/${params.serviceTeamId}`);

// 获取预约时间列表
export const getTimeOfSubject = (params) => post('/elune/api/v1/booking/getTimeOfSubject', params);

//预约列表
export const getBookingRecord = (params) => post('/elune/api/v2/booking/booking-record', params);

// 预约详情 
export const getBookingDetail = (params) => get(`/elune/api/v1/booking/getBookingDetail/${params.id}?isCancel=${params.cancel}&serverType=mpc`);

// 记录是否有进入过直播间教室
export const recordIsEnterLiveRoom = (params) => post(`/elune/api/v1/booking/update/process/attend?processId=${params.processId}&uuid=${params.uuid}`);

// 查询反馈报告
export const getFeedback = (params) => get(`/elune/api/v1/booking/process/feedback/report/${params.processId}`);

// 校验学员某个时间是否预约过
export const processTimeCheck = (params) => post('/elune/api/v1/booking/check/member/process/time', params);

// 学员预约时点击下一步加锁
export const processTimeLock = (params) => post('/elune/api/v1/booking/lock/member/process/time', params);

// 测评报告
export const evaluationReport = (params) => get(`/elune/api/v1/booking/process/evaluation/report/${params.evaluationReportId}?serverType=mpc`);

// 用户信息
export const getUserInfo = () => get('nice/user-info').then(res => res.data);

// 根据saasid判断课程对应的产品
export const judgeCourseProductsById = (params) => get(`/elune/api/v1/booking/have-only-one-product?studentId=${params.studentId}&saasCourseId=${params.saasCourseId}`).then(res => res.data);


//取消预约，验证次数
export const verificationNumber = (params) => get(`/elune/api/v1/booking/cancel/process/verification/number/${params.processId}`);

// 问题修改
export const modifyMemberProcessQuestion = (params) => post('/elune/api/v1/booking/modify/member/process/question', params);

// 选择服务--获取学员拥有权限的产品列表
export const serveProductList = (params) => get(`/elune/api/v1/booking/member/have/permission/product/${params.serviceTeamId}`);
// 预约记录统计
export const getTabsCount = (params) => get('/elune/api/v2/booking/booking-record/count', params);
// 学员在某团队下的预约上线校验及测评预约次数校验
export const getOnline = (params) => post('/elune/api/v1/booking/member/booking/online', params);

// 通过测评报告id获取预约信息
export const getServiceTeamId = (evaluationContentId) => get(`/elune/api/v1/booking/pass/evaluation/member/process/${evaluationContentId}`);

//获取约选择的老师列表
export const getTeacherList = (params) => post('/elune/api/v1/booking/teacher/list', params);

//获取老师可预约时间
export const getTeacherTime = (params) => post('/elune/api/v1/booking/teacher/time', params);

//获取对应的SP科目
export const getSpSubjectTask = (params) => get('/elune/api/v1/booking/find/product/subject', params);


// nps查询评价弹窗问题列表  场景id 不同场景见配置表
// 查询评价弹窗问题列表
export const getEvaluationListTask = (params) => get('/evaluation/api/v1/evaluation/12', params);

export const getUserInfoByTokenTask = () => get('/passport/api/v3/user/get-user-info-by-token');

// 获取测评地址
export const getReportUrl = params => get('/ep-study/front/report/url', params);
